import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  kitchen_divisions: [],
};

const getters = {
  allKitchenDivisions: (state) => state.kitchen_divisions,
};

const actions = {
  async fetchKitchenDivisions({ commit }, params = {}) {
    try {
      commit("resetKitchenDivisions");
      const response = await axios.get("/kitchen-division", { params: prm(params) });
      commit("setKitchenDivisions", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch kitchen_divisions:", error);
    }
  },
  async createKitchenDivision({ commit }, kitchen_division) {
    try {
      const response = await axios.post("/kitchen-division", kitchen_division);
      commit("addKitchenDivision", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create kitchen_division:", error);
      throw error;
    }
  },
  async fetchKitchenDivisionById(_, id) {
    try {
      const response = await axios.get(`/kitchen-division/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch kitchen_division:", error);
      throw error;
    }
  },
  async updateKitchenDivision({ commit }, kitchen_division) {
    try {
      const response = await axios.put(`/kitchen-division/${kitchen_division.id}`, kitchen_division);
      commit("updateKitchenDivision", response.data);
    } catch (error) {
      console.error("Failed to update kitchen_division:", error);
      throw error;
    }
  },
  async deleteKitchenDivisionById({ commit }, id) {
    try {
      const response = await axios.delete(`/kitchen-division/${id}`);
      commit("removeKitchenDivision", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete kitchen_division:", error);
      throw error;
    }
  },
};

const mutations = {
  setKitchenDivisions(state, kitchen_divisions) {
    state.kitchen_divisions = kitchen_divisions.data; // Ensure this matches your API's response structure
  },
  addKitchenDivision(state, kitchen_division) {
    state.kitchen_divisions.push(kitchen_division);
  },
  updateKitchenDivision(state, updatedKitchenDivision) {
    const index = state.kitchen_divisions.findIndex(
      (kitchen_division) => kitchen_division.id === updatedKitchenDivision.id
    );
    if (index !== -1) {
      state.kitchen_divisions.splice(index, 1, updatedKitchenDivision);
    }
  },
  removeKitchenDivision(state, id) {
    state.kitchen_divisions = state.kitchen_divisions.filter(
      (kitchen_division) => kitchen_division.id !== id
    );
  },
  resetKitchenDivisions(state) {
    state.kitchen_divisions = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
